/* global JSX */
// CheckBox
// ***********************************************************************************************************************
import * as React from "react";

export interface ICheckBoxProp {
    title: string | JSX.Element;
    classes?: string;
    inline?: boolean;
    disabled?: boolean;
    hidden?: boolean;
    labelClasses?: string;
    noPadding?: boolean;
    name?: string;
    checked: boolean;
    indeterminate?: boolean;
    onClick?: (e: any) => void;
    onClickBoolean?: (checked: boolean) => void;
}

export class CheckBox extends React.Component<ICheckBoxProp, {}> {
    private chkBox: HTMLInputElement;

    handleClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        if (props.disabled || !props.onClickBoolean) return;
        props.onClickBoolean(e.target.checked);
    };

    //To prevent react warning message
    handleChange = (e) => {
    };

    componentDidMount(): void {
        this.chkBox.indeterminate = !!this.props.indeterminate && !this.props.checked;
    }

    componentDidUpdate(prevProps) {
        if (!!prevProps.indeterminate !== !!this.props.indeterminate || prevProps.checked !== this.props.checked) {
            this.chkBox.indeterminate = !!this.props.indeterminate && !this.props.checked;
        }
    }

    render() {
        const props = this.props;
        if (props.hidden) return null;
        return (
            <div className={"form-check" + (props.inline ? " form-check-inline" : "") + (props.classes ? " " + props.classes : "") + (props.disabled ? " disabled" : "") + (props.noPadding ? " noPadding" : "")}>
                <label className={props.labelClasses ? props.labelClasses : ""}>
                    <input type="checkbox" ref={(el) => { this.chkBox = el; }} name={props.name} checked={props.checked} onClick={props.onClick ? props.onClick : this.handleClick} value="" onChange={this.handleChange} disabled={props.disabled} readOnly={props.disabled} />
                    {!!props.title &&
                        <div className="textContainer">{props.title}</div>
                    }
                </label>
            </div>
        );
    }
}